<v-public-bottom-gradient-wrapper>
  <div
    class="flex flex-col gap-10 w-[90vw] md:min-w-sm md:w-xl relative max-w-[480px]">
    <v-public-logo-header
      [header]="'pages.notificationPreferences.header' | transloco"
      [subheader]="
        'pages.notificationPreferences.subheader' | transloco
      "></v-public-logo-header>

    <v-card variant="glass-v2" padding="lg">
      <div slot="body">
        <h3 class="font-medium text-primary mb-4">
         {{ 'resources.notificationSchedule.plural.long' | transloco}}
        </h3>


        @if(!isEmpty()) {
          <v-notification-schedules-list
            [scheduleEntities]="scheduleEntitiesIterable()"
            [showSendTestNotification]="false"
            [showEdit]="false"
            (scheduleDeleted)="deleteSchedule($event)"
            (scheduleDisabled)="disableSchedule($event)"
            (scheduleEnabled)="enableSchedule($event)"
          ></v-notification-schedules-list>
        } @else {
          <v-empty-state [header]="'resources.notificationSchedule.empty.header' | transloco"></v-empty-state>
        }

      <div class="flex justify-end mt-8">
        <v-button-v2 [routerLink]="['/dashboard']">
          {{ 'pages.notificationPreferences.visitDashboard' | transloco }}
        </v-button-v2>
      </div>
      </div>
      </v-card>
  </div>
</v-public-bottom-gradient-wrapper>
